module.exports = __webpack_public_path__ + "static/img/empty.f7bccaae.png";